export class Reg {
/* step one */
lastName: string;
registrationID: string;
userType: string;
StrOldUserID: string;

/* step two */
email: string;
jwtToken: string;
newUid: string;
password: string;
reNewUid: string;
rePassword: string;
secretQuestion: string;
secretQuestion2: string;
secretQuestion3: string;
secretQuestionAnswer: string;
secretQuestionAnswer2: string;
secretQuestionAnswer3: string;

}
